import { action, observable, reaction, makeObservable } from 'mobx';
import {
  ContentLookup,
  contentLookupService,
  VersionedContentLookup,
  X2AgeCategory,
  X3Level
} from '../../../domain';
import {arrayToMap, Disposers, PromiseState} from '../../../lib/helpers';

export class X2AgeCategoryLoader {
  @observable.ref
  state: PromiseState<VersionedContentLookup> | null;
  @observable.ref
  lookup: ContentLookup | null;
  @observable.ref
  ageCategory: X2AgeCategory | null;
  @observable.ref
  levels: readonly X3Level[];
  @observable.ref
  levelById: { [index: number]: X3Level };

  private readonly disposers = new Disposers();

  constructor(readonly ageCategoryId: number) {
    makeObservable(this);
    this.state = null;
    this.lookup = null;
    this.ageCategory = null;
    this.levels = [];
    this.levelById = {};
    this.setup();
  }

  @action
  load = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.load();
  };

  @action
  refresh = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.refresh();
  };

  private setup() {
    this.disposers.add(reaction(
      () => this.state?.state,
      this.onStateChange));
  }

  @action
  private onStateChange = () => {
    this.lookup = null;
    this.ageCategory = null;
    this.levels = [];
    this.levelById = {};

    if (this.state?.isResolved !== true)
      return;
    let lookup = this.state.value.lookup;
    let ageCategory = lookup.X2AgeCategoryById[this.ageCategoryId];
    if (ageCategory === undefined)
      return;
    this.lookup = lookup;
    this.ageCategory = ageCategory;
    this.levels = ageCategory.Levels!;
    this.levelById = arrayToMap(this.levels, x => x.Id);
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
